import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.map";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop } from 'vue-property-decorator';
import { deepClone } from '@/utils';
import apis from '@/apis/caseManage';
import BreadcrumbHeader from '../Layout/BreadcrumbHeader.vue';
import MemberInfoForm from './components/MemberInfoForm/index.vue';
import BaseInfoForm from './components/BaseInfoForm.vue';
import ScheduleCase from './components/ScheduleCase.vue';
import UploadEvidents from './components/UploadEvidents.vue';

var CaseEdit = /*#__PURE__*/function (_Vue) {
  _inherits(CaseEdit, _Vue);

  var _super = _createSuper(CaseEdit);

  function CaseEdit() {
    var _this;

    _classCallCheck(this, CaseEdit);

    _this = _super.apply(this, arguments);
    _this.editIndex = '0';
    _this.litigationStatusIdOptions = [];
    _this.isSubmitting = false;
    return _this;
  }

  _createClass(CaseEdit, [{
    key: "mounted",
    value: function mounted() {
      this.initInEdit();
    }
  }, {
    key: "initInEdit",
    value: function initInEdit() {
      var baseInfoComp = this.$refs.baseInfoForm;
      var memberInfoForm = this.$refs.memberInfoForm; // console.log('baseInfoComp', baseInfoComp.baseInfoForm)

      apis.caseDetail({
        caseIndexCode: this.id
      }).then(function (res) {
        var data = res.data;
        if (data.registerTime) data.registerTime = new Date(data.registerTime);
        baseInfoComp.baseInfoForm = data; // 案由多选兼容配置-start

        var caseReasonId = baseInfoComp.baseInfoForm.caseReasonId.split(';');
        var caseReasonName = baseInfoComp.baseInfoForm.caseReasonName.split(';');
        var length = caseReasonId.length || 0;
        var values = [];
        var datas = [];

        for (var i = 0; i < length; i++) {
          values.push(caseReasonId[i]);
          datas.push({
            id: caseReasonId[i],
            caseActionName: caseReasonName[i]
          });
        }

        baseInfoComp.baseInfoForm.caseReasonIds = {
          values: values,
          datas: datas
        }; // 案由多选兼容配置-end

        memberInfoForm.clientList = data.partyList; // 将 partyUuid 处理为 代理对象详情列表

        data.procuratorList.forEach(function (procurator) {
          procurator.dldx = [];
          procurator.partyUuid.split(',').forEach(function (uuid) {
            var party = data.partyList.find(function (item) {
              return item.uuid === uuid;
            });

            if (party) {
              procurator.dldx.push(party);
            }
          });
        });
        memberInfoForm.proxyList = data.procuratorList;
      }).catch(function (_) {});
    }
  }, {
    key: "handleEditIndexChange",
    value: function handleEditIndexChange(index) {
      this.editIndex = index;
    } // 审判程序改变时，请求诉讼地位

  }, {
    key: "handleTrialProgramChange",
    value: function () {
      var _handleTrialProgramChange = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(parentId) {
        var _this2 = this;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                apis.trialProgramTree({
                  parentId: parentId
                }).then(function (res) {
                  _this2.litigationStatusIdOptions = res.data;
                }).catch(function (_) {
                  _this2.litigationStatusIdOptions = [];
                });

              case 1:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function handleTrialProgramChange(_x) {
        return _handleTrialProgramChange.apply(this, arguments);
      }

      return handleTrialProgramChange;
    }() // 点击保存

  }, {
    key: "handleSave",
    value: function handleSave() {
      var _this3 = this;

      this.$refs.baseInfoForm.handleSubmit(function (valid) {
        if (valid) {
          _this3.$refs.memberInfoForm.handleSubmit(function (memberValid) {
            if (memberValid) {
              _this3.submit();
            } else {
              _this3.editIndex = '1';
            }
          });
        } else {
          _this3.editIndex = '0';
        }
      });
    }
  }, {
    key: "submit",
    value: function submit() {
      var _this4 = this;

      this.isSubmitting = true;
      var data = this.$refs.baseInfoForm.baseInfoForm;
      var registerTime = data.registerTime; // 拷贝

      var params = deepClone(data); // 案由多选兼容配置-start

      params.caseReasonId = params.caseReasonIds.datas.map(function (val) {
        return val.id;
      }).join(';');
      params.caseReasonName = params.caseReasonIds.datas.map(function (val) {
        return val.caseActionName;
      }).join(';');
      delete params.caseReasonIds; // 案由多选兼容配置-end
      // 处理立案时间

      params.registerTime = registerTime.toLocaleDateString().split('/').join('-'); // 处理代理对象为 uuid 数组

      params.procuratorList.forEach(function (procurator) {
        procurator.partyUuid = procurator.dldx.map(function (dldx) {
          return dldx.uuid;
        }).join();
      }); // console.log('params:', params)

      setTimeout(function () {
        apis.updateCase(params).then(function (res) {
          var code = res.code,
              msg = res.msg; // console.log(code, msg)

          if (code === '0') {
            if (msg === 'reScheduled') {
              _this4.$message.warning('该案件为已排期的案件，需要重新排期对本次编辑的内容进行更新');
            } else {
              _this4.$message.success('编辑成功');
            }
          } // 延时跳转


          setTimeout(function () {
            _this4.$router.go(-1);

            _this4.isSubmitting = false;
          }, 2000);
        }).catch(function (e) {
          _this4.isSubmitting = false;
        });
      }, 500 + 500 * Math.random());
    }
  }, {
    key: "cancel",
    value: function cancel() {
      this.$router.go(-1);
    }
  }]);

  return CaseEdit;
}(Vue);

__decorate([Prop({
  required: true
})], CaseEdit.prototype, "id", void 0);

CaseEdit = __decorate([Component({
  components: {
    BaseInfoForm: BaseInfoForm,
    BreadcrumbHeader: BreadcrumbHeader,
    MemberInfoForm: MemberInfoForm,
    ScheduleCase: ScheduleCase,
    UploadEvidents: UploadEvidents
  }
})], CaseEdit);
export default CaseEdit;